import css from 'styled-jsx/css'

import {} from '../../theme'


export default css`
  
`
